module.exports = __webpack_public_path__ + "img/c03techsacredgrove_ua.a68c1ba2.webp";